export default {
  title: 'Solicitudes',
  buttons: {
    cleanAll: 'Limpiar todo'
  },
  subtitle: {
    thisMonth: 'Este mes',
    previous: 'Anteriores'
  },
  header: {
    id: 'ID',
    date: 'Fecha creación',
    type: 'Tipo',
    status: 'Estado',
    amountAuthorized: 'Monto',
    refund: 'Reembolso',
    coverage: 'Cobertura'
  },
  dateFilter: 'Rango de fechas',
  status: {
    all: 'Todos',
    pendingReview: 'En dictamen',
    claimed: 'Dictaminado',
    error: 'Error',
    paid: 'Pagado',
    voided: 'Anulado',
    ready: 'En dictamen',
    partiallyClaimed: 'Reclamo parcial',
    qualification: 'Validación pendiente',
    incomplete: 'Información pendiente',
    rejected: 'Rechazada',
    approved: 'Aprobada',
    requestInProgress: 'En progreso',
    creditCardBalance: {
      qualification: 'Validación pendiente',
      incomplete: 'Información pendiente',
      rejected: 'Rechazada',
      approved: 'Aprobada',
      claimed: 'Finiquitada',
      settlementRequired: 'Se requiere adjuntar archivo de finiquito'
    }
  },
  types: {
    pharmacy: 'Farmacia',
    process: 'Procedimiento',
    prescriptionDrugs: 'Medicamentos',
    diagnosticTest: 'Pruebas de diagnóstico',
    sports: 'Deportes',
    wellness: 'Gastos medicos',
    education: 'Educación',
    creditCardBalance: 'Saldo deudor',
    occupationalHazard: 'Riesgo laboral',
    prescription: 'Programación de medicamento',
    hospitalization: 'Ingreso hospitalario',
    therapy: 'Programación de terapias',
    medicalFees: 'Honorarios médicos',
    hospitalDischarge: 'Notificación de alta hospitalar',
    medicalReport: 'Informe médico'
  },
  graph: {
    remanentLabel: 'Remanente',
    total: 'Total',
    used: 'Utilizado',
    available: 'Disponible'
  },
  filters: {
    inputSearchPlaceholder: 'Buscar por ID',
    filterByLabel: 'Filtrar por',
    stateFilterLabel: 'Estado',
    dateFilterLabel: 'Rango de fechas'
  },
  filtersTitle: 'Filtros',
  resultsTitle: 'resultados',
  itemsPerPage: 'Resultados / Página',
  orderBy: 'Ordenar por',
  cleanFilter: 'Limpiar Filtros',
  apply: 'Aplicar',
  cleanFilters: 'limpiando los filtros'
}
